/* eslint-disable */
import MarqueeSpan from "./MarqueeSpan"

const Marquee = ({ bgColor, textColor}) => {
  return (
    <marquee className={`${bgColor} ${textColor} h-[40px] sm:h-[50px] md:h-[60px] text-xl sm:text-2xl md:text-3xl font-bold`} behavior='scroll' loop='infinite'>
      <MarqueeSpan middleText='for' emoji='💖' middleColor='text-pink-500' />
      <MarqueeSpan middleText='like' emoji='🌟' middleColor='text-[#ff7f4d]'/>
      <MarqueeSpan middleText='with'emoji='💅' middleColor='text-[#b693ff]'/>
      <MarqueeSpan middleText='for' emoji='💖' middleColor='text-pink-500' />
      <MarqueeSpan middleText='like' emoji='🌟' middleColor='text-[#ff7f4d]'/>
      <MarqueeSpan middleText='with'emoji='💅' middleColor='text-[#b693ff]'/>
      <MarqueeSpan middleText='for' emoji='💖' middleColor='text-pink-500' />
      <MarqueeSpan middleText='like' emoji='🌟' middleColor='text-[#ff7f4d]'/>
      <MarqueeSpan middleText='with'emoji='💅' middleColor='text-[#b693ff]'/>
      <MarqueeSpan middleText='for' emoji='💖' middleColor='text-pink-500' />
      <MarqueeSpan middleText='like' emoji='🌟' middleColor='text-[#ff7f4d]'/>
      <MarqueeSpan middleText='with'emoji='💅' middleColor='text-[#b693ff]'/>
      <MarqueeSpan middleText='for' emoji='💖' middleColor='text-pink-500' />
      <MarqueeSpan middleText='like' emoji='🌟' middleColor='text-[#ff7f4d]'/>
      <MarqueeSpan middleText='with'emoji='💅' middleColor='text-[#b693ff]'/>
      <MarqueeSpan middleText='for' emoji='💖' middleColor='text-pink-500' />
      <MarqueeSpan middleText='like' emoji='🌟' middleColor='text-[#ff7f4d]'/>
      <MarqueeSpan middleText='with'emoji='💅' middleColor='text-[#b693ff]'/>
      <MarqueeSpan middleText='for' emoji='💖' middleColor='text-pink-500' />
      <MarqueeSpan middleText='like' emoji='🌟' middleColor='text-[#ff7f4d]'/>
      <MarqueeSpan middleText='with'emoji='💅' middleColor='text-[#b693ff]'/>
      <MarqueeSpan middleText='for' emoji='💖' middleColor='text-pink-500' />
      <MarqueeSpan middleText='like' emoji='🌟' middleColor='text-[#ff7f4d]'/>
      <MarqueeSpan middleText='with'emoji='💅' middleColor='text-[#b693ff]'/>
      <MarqueeSpan middleText='for' emoji='💖' middleColor='text-pink-500' />
      <MarqueeSpan middleText='like' emoji='🌟' middleColor='text-[#ff7f4d]'/>
      <MarqueeSpan middleText='with'emoji='💅' middleColor='text-[#b693ff]'/>
      <MarqueeSpan middleText='for' emoji='💖' middleColor='text-pink-500' />
      <MarqueeSpan middleText='like' emoji='🌟' middleColor='text-[#ff7f4d]'/>
      <MarqueeSpan middleText='with'emoji='💅' middleColor='text-[#b693ff]'/>
      <MarqueeSpan middleText='for' emoji='💖' middleColor='text-pink-500' />
      <MarqueeSpan middleText='like' emoji='🌟' middleColor='text-[#ff7f4d]'/>
      <MarqueeSpan middleText='with'emoji='💅' middleColor='text-[#b693ff]'/>
      <MarqueeSpan middleText='for' emoji='💖' middleColor='text-pink-500' />
      <MarqueeSpan middleText='like' emoji='🌟' middleColor='text-[#ff7f4d]'/>
      <MarqueeSpan middleText='with'emoji='💅' middleColor='text-[#b693ff]'/>
      <MarqueeSpan middleText='for' emoji='💖' middleColor='text-pink-500' />
      <MarqueeSpan middleText='like' emoji='🌟' middleColor='text-[#ff7f4d]'/>
      <MarqueeSpan middleText='with'emoji='💅' middleColor='text-[#b693ff]'/>
      <MarqueeSpan middleText='for' emoji='💖' middleColor='text-pink-500' />
      <MarqueeSpan middleText='like' emoji='🌟' middleColor='text-[#ff7f4d]'/>
      <MarqueeSpan middleText='with'emoji='💅' middleColor='text-[#b693ff]'/>
    </marquee>
  )
}

export default Marquee
